// import thunk from 'redux-thunk';
// import logger from "./Logger";
// import {applyMiddleware} from 'redux';
// export default applyMiddleware(thunk,logger);
import {isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { errorHandler } from "../utils/errors";

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action)) {
      errorHandler(action.error)

    }

    return next(action);
  };

